export default __webpack_public_path__ + "static/poster-2ea68e0cc299ff2dffec4e1bb840c8c9.png";